'use strict'

const ReactRedux = require('react-redux');
var React = require('react');
let BaseComponent = require('../shared/base');

var FooterLayout = require('../layouts/footer').FooterLayoutComponent;
var HeaderLayout = require('../layouts/header').HeaderLayoutComponent;
let OrderAgilComponent = require('../../views/order-agil/order-agil');
let client = require('../../../sdk/client');

class AgilComponent extends BaseComponent {

    componentDidMount(){
        let self = this;
        if (this.props.user != null) {
            client.Users.getUserDetails({
                excludeToken: false,
                userId: self.props.user.ID,
                includeUserCustomFields: true
            }, function (err, user) {
                if (err == null && user != null) {
                    self.props.user.CustomFields = user.CustomFields;
                }
            });
        }
    }

    render() {

        return (
            <React.Fragment>
                <div className="header mod" id="header-section">
                    <HeaderLayout categories={this.props.categories} user={this.props.user} ControlFlags={this.props.controlFlags} />
                </div>
                <div className="main" id="orderagil-main">
                    <OrderAgilComponent user={this.props.user} />
                </div>
                <div className="footer" id="footer-section">
                    <FooterLayout panels={this.props.panels} />
                </div>
            </React.Fragment>
        );
    }
}


function mapStateToProps(state, ownProps) {
    return {
        user: state.userReducer.user
    };
}

function mapDispatchToProps(dispatch) {
    return {};
}

const OrderAgilHome = ReactRedux.connect(
    mapStateToProps,
    mapDispatchToProps
)(AgilComponent);

module.exports = {
    OrderAgilHome,
    AgilComponent,
};